import cn from "classnames";
import { IMinerProfileEditorStore } from "@mobx/store/minerProfiles/editor";
import { observer } from "mobx-react-lite";
import { useIntl } from "react-intl";
import StaticValueField from "../StaticValueField/StaticValueField";
import { IEfficiencyFieldProps } from "./EfficiencyField.props";
import styles from "./EfficiencyField.module.scss";

function EfficiencyField({
  editorStore,
  isError,
  className,
}: IEfficiencyFieldProps & {
  readonly editorStore: IMinerProfileEditorStore;
}) {
  const { formatMessage } = useIntl();

  return (
    <StaticValueField
      id='efficiency'
      label={formatMessage({ id: "calc.efficiency" })}
      value={editorStore.efficiency}
      unit={editorStore.efficiencyUnit}
      isError={isError}
      className={cn(styles.wrapper, className)}
      unitClassName={styles.unit}
      disabled
      readOnly
    />
  );
}

export default observer(EfficiencyField);
